import { PeopleEmployeeDto } from "./people-employee.dto";

export class PeopleEmployeeFileDto {
    id?: number;
    employeeId?: number;
    name?: string;
    description?: string;
    fileType?: string;
    fileURL?: string;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;

    employee?: PeopleEmployeeDto;
}